(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mb-product-recs"]) return;
  try {
    
  document.querySelectorAll('[data-recs]').forEach(function (el) {
    if (el.children.length) return;
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recs]');
      if (fresh && fresh.children.length) el.innerHTML = fresh.innerHTML;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
